import {withLeanStyles} from '@wix/native-components-infra/dist/es/src/HOC/withStyles/withLeanStyles';
import {bootstrapAppBase} from './bootstrapBase';

/* istanbul ignore next: todo: test */
export const bootstrapAppNoCss = (Component: React.ComponentType, options: {cssPath?: string[]} = {}) => {
  return bootstrapAppBase(Component, withLeanStyles, options);
};
